import React from "react";
import {
    isCustomSession,
    isPaperSession,
    isSpecialSession,
    timeStringToSeconds,
} from "../commons";
import { API_URL, minutesPerSlot, slotHeight, slotWidth } from "../constants";
import { connect } from "react-redux";
import { addToUnassigned, deleteCalendarSession } from "../redux/actions";

class CalendarSession extends React.Component {
    constructor(props) {
        super(props);

        this.handleDeleteClick = this.handleDeleteClick.bind(this);
        this.handleDragStart = this.handleDragStart.bind(this);
    }

    handleDeleteClick() {
        const calendarSessionId = this.props.calendarSession.id;
        fetch(API_URL + "/calendar/" + calendarSessionId, {
            method: "DELETE",
            headers: {
                Authorization: "Bearer " + this.props.user.api_token,
            },
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText); // Will go to .catch

                /* If session has been deleted correctly from the server side
            then remove it from the frontend side */
                this.props.deleteCalendarSession(calendarSessionId);

                this.props.addToUnassigned([this.props.session]);
            })
            .catch((error) => {
                alert(error);
            });
    }

    handleDragStart(event) {
        const data = {
            source: "calendarSession",
            session: this.props.calendarSession,
        };
        event.dataTransfer.setData("text/plain", JSON.stringify(data));
    }

    render() {
        const { calendarSession, session, sessionTypes } = this.props;

        // Compute calendar cell left position
        const left = this.props.colIdx * slotWidth;

        // Compute calendar cell height, based on the session duration
        const durationInMinutes =
            (timeStringToSeconds(calendarSession.end_time) -
                timeStringToSeconds(calendarSession.start_time)) /
            60;
        const height = (durationInMinutes / minutesPerSlot) * slotHeight;

        // Compute color based on session type
        let backgroundColor;
        if (isPaperSession(session)) {
            backgroundColor = session.data.panel_color;
        } else if (isSpecialSession(session)) {
            backgroundColor = "#FFFFCC";
        } else {
            backgroundColor = "#FFCCCC";
        }

        const style = {
            left: left + "px",
            height: height + "px",
            backgroundColor: backgroundColor,
        };

        let name = "";
        if (isCustomSession(session)) {
            name = session.data.name;
        } else if (isPaperSession(session) || isSpecialSession(session)) {
            name = session.data.short_name ?? session.type;
        } else {
            name = session.data.name;
        }

        let subName = "";
        if (isSpecialSession(session) && session.data.author) {
            subName = session.data.author;
        } else if (isPaperSession(session)) {
            subName = session.data.name;
        }

        let tooltip = session.type + "\n";
        for (const field of sessionTypes[session.type]["fields"]) {
            tooltip +=
                field.display_name + ": " + session.data[field.name] + "\n";
        }

        let time = 0;
        if (session.papers) {
            for (let i = 0; i < session.papers.length; i++) {
                time += session.papers[i].duration;
            }
        }

        return (
            <div
                id={"c" + calendarSession.id}
                className={"overlay r" + calendarSession.room.id + " dragthis"}
                style={style}
                draggable="true"
                onDragStart={this.handleDragStart}
            >
                <div>
                    <span
                        className="glyphicon glyphicon-trash pointer pull-right gi-08x deletecalendarsession"
                        onClick={this.handleDeleteClick}
                    ></span>
                    <span
                        className="glyphicon glyphicon-cog pointer pull-right gi-08x openmodal-editcalendarsession"
                        aria-hidden="true"
                        onClick={(e) =>
                            this.props.handleShowEdit(calendarSession.id, e)
                        }
                    ></span>
                    <span
                        className="glyphicon glyphicon-zoom-in pointer pull-right gi-08x openmodal-showcalendarsession"
                        aria-hidden="true"
                        onClick={(e) =>
                            this.props.handleShowDetail(calendarSession.id, e)
                        }
                    ></span>
                    <span className="ov_event-date">
                        {calendarSession.start_time.slice(0, -3) +
                            " - " +
                            calendarSession.end_time.slice(0, -3)}
                    </span>
                    <span className="tt" aria-hidden="true" title={tooltip}>
                        <span className="ov_event-name">
                            {name}
                            {time > 0 ? ` - ${time} min` : " "}
                        </span>
                    </span>
                </div>
                <div className="ov_specificSubDiv">
                    <span>{subName}</span>
                </div>
            </div>
        );
    }
}

export default connect(null, { deleteCalendarSession, addToUnassigned })(
    CalendarSession
);
